import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import * as _ from 'lodash';
import {DataTableDirective} from 'angular-datatables';
import {ActivatedRoute, Router} from '@angular/router';
import {ColumnTableCustom} from '../../model/column-table-custom';
import {Subject, Subscription, timer} from 'rxjs';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { HttpCustomService } from 'src/service/http-custom.service';
import { TableConfigModel } from 'src/shared/model/table-config-model';
import { FooterInfo } from 'src/shared/model/footer-info';
import { ConvertStatusCodeService } from 'src/shared/service/convert-status-code.service';
import { HeaderColumnTableCustom } from 'src/shared/model/header-column-table-custom';
import {switchMap} from 'rxjs/operators';
import { NumberConstants } from 'src/shared/constants/common-constants.enum';
import {BsModalService} from "ngx-bootstrap/modal";
@Component({
  selector: 'dcu-table-common',
  templateUrl: './table-common.component.html',
  styleUrls: ['./table-common.component.scss']
})
export class TableCommonComponent implements OnInit, OnChanges, OnDestroy {

  dtOptions: DataTables.Settings = {};
  ngUnsubscribe: Subject<boolean> = new Subject<boolean>();
  contents = [];
  isAllSelected = false;
  selectedStatusCode: string;
  searchedValue = '';
  private footerInfo = new FooterInfo();
  currentPage = 0;
  processing = true;
  tableColumns: ColumnTableCustom[] = [];
  tableHeaderColumns: HeaderColumnTableCustom[] = [];
  subscriptions: Subscription[] = [];

  extendedColumns = [
    {
      name: 'Created By',
      data: 'createdBy',
    },
    {
      name: 'Created On',
      data: 'createdOn',
      type: 'date'
    },
    {
      name: 'Last Modified By',
      data: 'modifiedBy',
    },
    {
      name: 'Last Modified On',
      data: 'modifiedOn',
      type: 'date'
    }
  ];

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;

  @Input()
  tableConfig: TableConfigModel;

  @Input()
  refresh = false;

  @Input()
  selectedValues: { [key: number]: any } = {};

  @Input() idTable = 'table1';

  @Output()
  selectedValueChange = new EventEmitter();

  @Output()
  rowSelectedChange = new EventEmitter();

  @Output()
  onCloseChange = new EventEmitter();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private httpService: HttpCustomService,
    private bsModalService: BsModalService,
  ) {
  }

  ngOnInit() {
    if (this.tableConfig.defaultStatus) {
      this.selectedStatusCode = this.tableConfig.defaultStatus;
    }

    this.initialTableSettings();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.refresh && !changes.refresh.firstChange
      && changes.refresh.previousValue !== changes.refresh.currentValue) {
      this.selectedValues = {};
      this.isAllSelected = false;
      this.reloadTableContent();
      this.selectedValueChange.emit(this.selectedValues);
    }
  }

  initialColumns(): ColumnTableCustom[] {
    this.tableHeaderColumns = this.tableConfig.headerColumn;
    // need to get show columns
    this.tableColumns = this.tableConfig.columnData.filter(column => !column.isHidden);
    if (this.tableConfig.isExtendedColumns) {
      this.tableColumns = _.concat(this.tableColumns, this.extendedColumns);
    }
    if (this.tableConfig.enableCheckbox) {
      return _.concat(
        {
          orderable: false,
          searchable: false
        },
        {
          orderable: false,
          searchable: false
        },
        this.tableColumns
      );
    } else {
      return _.concat(
        {
          orderable: false,
          searchable: false
        },
        this.tableColumns
      );
    }
  }

  initialOrder(): [any] {
    return _.isEqual(typeof this.tableConfig.order, 'undefined')
      ? (_.isEqual(this.tableConfig.enableCheckbox, true) ? [2, 'asc'] : [1, 'asc']) : this.tableConfig.order;
  }

  checkAllRecord(event: any) {
    if (event.target.checked) {
      _.forEach(this.contents, (row: any) => {
        this.selectedValues[_.get(row, this.tableConfig.rowId)] = row;
      });
    } else {
      const removedKeys = this.contents.map(content => _.get(content, this.tableConfig.rowId));
      this.selectedValues = _.omit(this.selectedValues, removedKeys);
    }
    this.selectedValueChange.emit(this.selectedValues);
    this.actionAfterCheck();
  }

  private _clearTable() {
    this.currentPage = 0;
    this.isAllSelected = false;
    this.selectedValues = {};
  }

  onChangeSearchValue(searchedValue) {
    this.searchedValue = searchedValue;
    this._clearTable();
    this.reloadTableContent();
  }

  refreshTableOnCurrentPaging() {
    this.selectedValues = {};
    this.isAllSelected = false;
    this.reloadTableContentOnCurrentPaging();
    this.selectedValueChange.emit(this.selectedValues);
  }

  reloadTableContentOnCurrentPaging(): void {
    if (this.dtElement) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance
          .search(this.searchedValue ? this.searchedValue : '')
          .ajax.reload(null, false);
      });
      this.refresh = false;
    }
  }

  refreshTable() {
    this.selectedValues = {};
    this.isAllSelected = false;
    this.reloadTableContent();
    this.selectedValueChange.emit(this.selectedValues);
  }

  onChangeSearchDate(date: any) {
    if (_.isUndefined(this.tableConfig.customParams)) {
      this.tableConfig.customParams = {};
    }

    if (date) {
      _.assign(this.tableConfig.customParams, {effectiveDate: moment(date).utc().format('YYYY-MM-DD')});
    } else {
      this.tableConfig.customParams = _.omit(this.tableConfig.customParams, 'effectiveDate');
    }

    this._clearTable();
    this.reloadTableContent();
  }

  onChangeStatusValue(selectedStatusCode: any) {
    this.selectedStatusCode = selectedStatusCode;
    this._clearTable();
    this.reloadTableContent();
  }

  onEdit(rowData) {
    const id = _.get(rowData, this.tableConfig.rowId);
    const routerId = _.get(rowData, this.tableConfig.columnNameRouter);
    if (id) {
      if (routerId) {
        if (this.tableConfig.editUrl) {
          this.router.navigateByUrl(this.tableConfig.editUrl.replace(':routerId', routerId), {relativeTo: this.route}).finally();
        }
      } else {
        if (this.tableConfig.editUrl) {
          if (this.tableConfig.editTarget) {
            this.openNewTab(`${this.tableConfig.editUrl}/${id}`, this.tableConfig.editTarget);
            return;
          }
        } else {
          this.router.navigate(['../edit', id], {relativeTo: this.route}).finally();
        }
      }
    }
  }

  checkOneRecord(selectedRow: any, event: any) {
    if (event.target.checked) {
      this.selectedValues[_.get(selectedRow, this.tableConfig.rowId)] = selectedRow;
    } else {
      delete this.selectedValues[_.get(selectedRow, this.tableConfig.rowId)];
    }

    this.selectedValueChange.emit(this.selectedValues);
    this.actionAfterCheck();
  }

  private initialTableSettings() {
    const that = this;
    this.dtOptions = {
      info: true,
      serverSide: true,
      // scrollX: true,
      columns: that.initialColumns(),
      dom: '<\'form-inline\'<\'table-common w-100\'tr>><\'row footer-wrapper\'<\'footer-item\'<\'d-inline-block mr-2\'i><\'d-inline-block\'l>><\'footer-item ml-md-auto\'p>>',
      language: {
        paginate: {
          first: '',
          last: '',
          next: 'Next',
          previous: 'Prev'
        },
        aria: {
          paginate: {
            first: 'First',
            previous: 'Prev',
            next: 'Next',
            last: 'Last'
          },
          sortAscending: '>',
          sortDescending: '<'
        },
        infoEmpty: '',
      },
      paging: !this.tableConfig.isPageable,
      infoCallback: (settings, start, end, max, total, pre) => {
        this.footerInfo.start = start;
        this.footerInfo.end = end;
        this.footerInfo.total = total;
        if (this.tableConfig.isPageable) {
          return `1 - ${total} of ${total} (${_.size(this.selectedValues)} selected)`;
        }
        return `${end === 0 ? 0 : start} - ${end} of ${total} (${_.size(this.selectedValues)} selected)`;

      },
      lengthMenu: environment.datatable.lengthMenu,
      pageLength: environment.datatable.pageLength,
      order: that.initialOrder()
    };

    this.getSearchData();
    this.footerMessage();
  }

  private getSearchData() {
    this.dtOptions.ajax = (dataTablesParameters: any, callback) => {
      this.subscriptions.push(this.loadData(dataTablesParameters)
        .takeUntil(this.ngUnsubscribe).subscribe(resp => {
        this.processing = false;
        if (resp && resp.rows) {
          this.contents = resp.rows;
          this.currentPage = dataTablesParameters.start / dataTablesParameters.length;
          this.checkIfNoData();
          this.onSelectedAll();
        } else {
          // in order to make sure it will be refresh table without content
          this.contents = [];
        }

        callback({
          recordsTotal: resp ? resp.totalElements : 0,
          recordsFiltered: resp ? resp.totalElements : 0,
          data: []
        });
      },
      () => {
        this.processing = false;
        this.contents = [];
      }));
    };
  }

  private onSelectedAll() {
    if (_.size(this.contents) <= 0) {
      this.isAllSelected = null;
      return;
    } else {
      this.isAllSelected = true;
      _.forEach(this.contents, (row: any) => {
        if (this.selectedValues && !this.selectedValues[_.get(row, this.tableConfig.rowId)]) {
          this.isAllSelected = false;
          return;
        }
      });
    }

  }

  private loadData(tablePrams) {
    // process data table parameters
    let sortArr = tablePrams.order.map(item => `${tablePrams.columns[item.column].data},${item.dir}`);
    if (this.tableConfig.isCustomSorting) {
      const columns = this.initialColumns();
      sortArr = tablePrams.order.map(item => `${
        columns[item.column] && columns[item.column] ? columns[item.column].customSortingField : columns[item.column].data
      },${item.dir}`);
    }
    const options: any = {
      size: tablePrams.length,
      page: tablePrams.start / tablePrams.length
    };
    if (!this.tableConfig.ignoredSorting && this.initialOrder().length > 0) {
      options.sort = sortArr;
    }

    if (this.selectedStatusCode && this.selectedStatusCode !== '0') {
      options.status = this.selectedStatusCode;
    }

    if (tablePrams.search.value) {
      options.q = _.trim(tablePrams.search.value.replace(/\s/g, ' '));
    }

    if (this.tableConfig.customParams) {
      const keys = _.keys(this.tableConfig.customParams);
      for (const key of keys) {
        options[key] = this.tableConfig.customParams[key];
      }
    }

    if (this.tableConfig.ignoredNo) {
      options.ignoredNo = this.tableConfig.ignoredNo;
    }

    if (this.tableConfig.methodPost && this.tableConfig.dataPost) {
      return this.httpService.getList(this.tableConfig.urlStateParam, this.tableConfig.dataPost, options);
    } else {
      return this.httpService.get(this.tableConfig.urlStateParam, options);
    }
  }

  private actionAfterCheck() {
    this.footerInfo.selectedNumber = _.size(this.selectedValues);
    this.onSelectedAll();
    this.footerMessage();
  }

  private footerMessage() {
    const element = `#${this.idTable} .dataTables_info`;
    if (!this.tableConfig.isPageable) {
      $(element).text(
        `${this.footerInfo.end === 0
          ? 0 : this.footerInfo.start} - ${this.footerInfo.end} of ${this.footerInfo.total} (${this.footerInfo.selectedNumber} selected)`
      );
    } else {
      $(element).text(
        `1 - ${this.footerInfo.total} of ${this.footerInfo.total} (${this.footerInfo.selectedNumber} selected)`
      );
    }
  }

  reloadTableContent(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance
        .search(this.searchedValue ? this.searchedValue : '')
        .ajax.reload();
    });
    this.refresh = false;
  }

  private checkIfNoData() {
    const elementInfo = `#${this.idTable} .dataTables_info`;
    const elementLength = `#${this.idTable} .dataTables_length`;
    const elementPaginate = `#${this.idTable} .dataTables_paginate`;

    if (_.size(this.contents) > 0) {
      $(elementInfo).show();
      $(elementLength).show();
      $(elementPaginate).show();
    } else {
      $(elementInfo).hide();
      $(elementLength).hide();
      $(elementPaginate).hide();
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.unsubscribe();
  }

  unsubscribe(): void {
    _.forEach(this.subscriptions, sub => {
      sub.unsubscribe();
    })
    this.subscriptions = [];
  }

  onClickRow(row) {
    if (this.tableConfig.isClickRow) {
      this.rowSelectedChange.emit(row);
    }
  }


  private openNewTab(url: string, target: string) {
    window.open(url, target);
  }

  onCloseForm(event) {
    this.onCloseChange.emit(event);
  }

  formatDate(dateValue) {
    if (dateValue) {
      return moment(dateValue).local().format('DD/MM/YYYY');
    }
    return '';
  }

  formatDateTime(dateValue) {
    if (dateValue) {
      return moment(dateValue).local().format('DD/MM/YYYY HH:mm:ss');
    }
    return '';
  }

  reformatData(column: any, rowData: any) {

    const fieldName = column.data;
    const fieldContent = _.get(rowData, fieldName);
    const enumType = column.enumType;

    const customFields = column.customFields;

    const externalData = column.externalData;
    // only apply for external data
    if (externalData && _.size(externalData) > 0) {
      if (externalData[rowData.drugNo]) {
        return externalData[rowData.drugNo].partnerName;
      }
    }

    // do custom here
    if (customFields && _.size(customFields) > 0) {
      if (fieldContent && _.size(fieldContent) > 0) {
        if(_.isArray(fieldContent)){
          return _.join(fieldContent.map(content => _.join(customFields.filter(col => this.getColumnData(content, col, enumType)).map(col => this.getColumnData(content, col, enumType)), ':')), ';');
        }else {
          return this.getColumnData(fieldContent, customFields, enumType) ;
        }
      }
    }

    return this.getColumnData(rowData, fieldName, enumType);
  }

  getColumnData(rowData: any, fieldName: string, enumType?: any, col?: any) {
    let columnValue = _.get(rowData, fieldName);
    if (col && col.type === 'date') {
      return this.formatDate(columnValue);
    }
    if (!_.isNull(columnValue) || _.isNumber(columnValue)) {
      if (enumType) {
        columnValue = enumType[columnValue] ? enumType[columnValue] : columnValue;
      }
      return columnValue;
    }
    return '';
  }

  getRowId(rowData) {
    return _.get(rowData, this.tableConfig.rowId);
  }

  navigatePage(column: any, rowData: any) {
    let link = column.navigateLink;
    do {
      // Get value to replace
      link = this.getRouterLink(link, rowData);
    } while (link && _.indexOf(link, ':') > -1) ;

    // Navigate link
    this.router.navigate([link]).then(r => null);

    return false;
  }

  getRouterLink(link: string, rowData: any): string {
    // Get value to replace
    _.each(_.keys(rowData), key => {
      // Check wrap object in data
      if (rowData[key] instanceof Object && _.includes(link, key)) {
        _.each(_.keys(rowData[key]), subKey => {
          if (_.includes(link, key + '.' + subKey)) {
            link = _.replace(link, ':' + key + '.' + subKey, rowData[key][subKey]);
            return false;
          }
        });
      }

      // Check field in data
      if (_.includes(link, key)) {
        link = _.replace(link, ':' + key, rowData[key]);
        return false;
      }
    });
    return link;
  }

  public getStatusCssClass(status, prefix?) {
    return ConvertStatusCodeService.getClassByCode(status, prefix);
  }

  onEditRow(col: any, rowData: any) {
    const data = _.cloneDeep(rowData);
    const config = {
      backdrop: true,
      ignoreBackdropClick: true
    };
    const bsModalRef = this.bsModalService.show(col.editComponent,
      { ...config, initialState: {[col.initStateObject]: data, isEdit: true} });
    bsModalRef.setClass('modal-dialog-right');
  }

  togglePassword(index) {
    $(`.toggle-password-${index}`).toggleClass("fa-eye fa-eye-slash");
    let input = $(`#password-field-${index}`);
    if (input.attr("type") == "password") {
      input.attr("type", "text");
    } else {
      input.attr("type", "password");
    }
  }
}
